import React from "react";

const Clients = () => {
  return (
    <div className="container">
      <div className="row align-items-center justify-content-center">
        <div className="col-12">
          <div className="text-center mt-5 mb-4">
            <h2 className="fw-bold">
              Trusted by <span style={{color:'#ED1C24'}}>great brands</span>
            </h2>
            <p className="text-muted">
              We have worked with some of the most prestigious brands worldwide.
            </p>
            
          </div>
        </div>
        <div className="col-12">
          <div className="container">
            <div className="row p-4">
              <div className="col">
                <img
                  src="/assets/img/clients/accenture.svg"
                  className="img-fluid"
                  alt=""
                />
              </div>
              <div className="col">
              <img
                  src="/assets/img/clients/Capgemini.svg"
                  className="img-fluid"
                  alt=""
                />
              </div>
              <div className="col">
                <img
                  src="/assets/img/clients/Expedia.svg"
                  className="img-fluid"
                  alt=""
                />
                </div>
              <div className="col">
              <img
                  src="/assets/img/clients/Legero.svg"
                  className="img-fluid"
                  alt=""
                />
              </div>
            </div>
          </div>
          <div className="container">
            <div className="row p-4">
              <div className="col">
                <img
                  src="/assets/img/clients/AnytimeFitness.svg"
                  className="img-fluid"
                  alt=""
                />
              </div>
              <div className="col">
              <img
                  src="/assets/img/clients/BSIBusinessPark.svg"
                  className="img-fluid"
                  alt=""
                />
              </div>
              <div className="col">
                <img
                  src="/assets/img/clients/Gaurcity.svg"
                  className="img-fluid"
                  alt=""
                />
                </div>
              <div className="col">
              <img
                  src="/assets/img/clients/KailashHealthcare.svg"
                  className="img-fluid"
                  alt=""
                />
              </div>
            </div>
          </div>
          <div className="container">
            <div className="row p-4">
              <div className="col">
                <img
                  src="/assets/img/clients/PremiumVilla.svg"
                  className="img-fluid"
                  alt=""
                />
              </div>
              <div className="col">
              <img
                  src="/assets/img/clients/Samsung.svg"
                  className="img-fluid"
                  alt=""
                />
              </div>
              <div className="col">
                <img
                  src="/assets/img/clients/Tsuyo.svg"
                  className="img-fluid"
                  alt=""
                />
                </div>
              <div className="col">
              <img
                  src="/assets/img/clients/TVSMotor.svg"
                  className="img-fluid"
                  alt=""
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Clients;
